var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 25,
    viewBox: "0 0 49 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0498 18.5H15.0498V16.5H3.0498V18.5ZM3.0498 6.5V8.5H21.0498V6.5H3.0498ZM3.0498 13.5H21.0498V11.5H3.0498V13.5Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0498 17L40.0498 12.5L34.0498 8V17ZM36.0498 2.5C30.5298 2.5 26.0498 6.98 26.0498 12.5C26.0498 18.02 30.5298 22.5 36.0498 22.5C41.5698 22.5 46.0498 18.02 46.0498 12.5C46.0498 6.98 41.5698 2.5 36.0498 2.5ZM36.0498 20.5C31.6398 20.5 28.0498 16.91 28.0498 12.5C28.0498 8.09 31.6398 4.5 36.0498 4.5C40.4598 4.5 44.0498 8.09 44.0498 12.5C44.0498 16.91 40.4598 20.5 36.0498 20.5Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexMedia);
export default __webpack_public_path__ + "static/media/flex-media.95cf086bcef2be5130e0bd24bcdf7a49.svg";
export { ForwardRef as ReactComponent };